module.exports = __webpack_public_path__ + "static/media/prime.eeffc34c.PNG";